import { DISCUSSION_BOARD_PATH, PRIVATE_DISCUSSION_BOARD_PATH } from "@/lib/constants";
import CommunityTile from "../components/community-tile";
import { useCountryContext } from "@/providers/country-provider";
import { usePathname } from "next/navigation";

const communityData = [
	{
		labelText: "New",
		title: "Real Estate Agents Network",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/brokers-agents`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/communities/Brokers-and-Agents/B&A-logo.png`,
	},
	{
		labelText: "Hot",
		title: "Global PropTech Founders/CEOs",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/global-proptech-founders`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/communities/global-proptech-founders/global-proptech-founders-logo.png`,
	},
	{
		labelText: "Hot",
		title: "Women in the Built World",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/women-in-proptech`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/women-in-proptech/women-in-proptech-community-logo.png`,
	},
	{
		labelText: "New",
		title: "OnePropExpo",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/one-prop-expo`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/onePropExpo/onePropExpo-logo.png`,
	},
	{
		labelText: "Hot",
		title: "MULTIFAMILY X",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/multifamily-x`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/multifamily/multifamily-latest-logo.png`,
	},
	{
		labelText: "Hot",
		title: "Proptech India",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/proptech-india`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-india/proptech-india-logo.png`,
	},
	{
		labelText: "New",
		title: "Africa Valuation Conference",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/africa-valuation-conference`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/africa-valuation-conference/africa-valuation-conference-logo.png`,
	},
	{
		labelText: "Hot",
		title: "Global PropTech Forum",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/global-proptech-forum`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/general-discussion-board/general-discussion-board-logo.png`,
	},
	{
		labelText: "New",
		title: "AREA Uganda",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/area-uganda`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/area-uganda/area-uganda-logo.png`,
	},
	{
		labelText: "Hot",
		title: "US Proptech Council",
		labelTextClassName: "bg-red-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/us-proptech-council`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/us-proptech-council/us-proptech-logo.png`,
	},
	{
		labelText: "Hot",
		title: "Global VIP Private Room",
		labelTextClassName: "bg-red-500",
		href: `${DISCUSSION_BOARD_PATH}/vip-intro`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/communities/vip-channel-logo.png`,
	},
	{
		labelText: "Hot",
		title: "AI in Proptech",
		labelTextClassName: "bg-red-500",
		href: `${DISCUSSION_BOARD_PATH}/ai-in-proptech`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/discussion-board/ai-proptech-channel/ai-proptech-logo.png`,
	},
	{
		labelText: "New",
		title: "Dubai PropTech Business Group",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/dubai-proptech-business-group`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/dubai-proptech-business-group/dubai-proptech-logo.png`,
	},
	{
		labelText: "New",
		title: "Construction Tech",
		labelTextClassName: "bg-green-500",
		href: `${DISCUSSION_BOARD_PATH}/construction-tech`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/communities/construction-tech-logo.png`,
	},
	{
		labelText: "New",
		title: "Marketing in Proptech",
		labelTextClassName: "bg-green-500",
		href: `${DISCUSSION_BOARD_PATH}/marketing-in-proptech`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/communities/marketing-in-proptech-logo.png`,
	},
	{
		labelText: "Hot",
		title: "VIP VCs/Investors",
		labelTextClassName: "bg-red-500",
		href: `${DISCUSSION_BOARD_PATH}/vip-vc-investors`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/communities/vip-channel-logo.png`,
	},
	{
		labelText: "New",
		title: "International Students Accommodation Forum",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/international-students-accommodation-forum`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/isaf/isaf-logo.png`,
	},
	{
		labelText: "New",
		title: "Asia PropTech Forum",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/asia-proptech-forum`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-asia-forum/proptech-asia-forum-logo.jpg`,
	},
	{
		labelText: "New",
		title: "Global PropTech Summit Riyadh",
		labelTextClassName: "bg-green-500",
		href: `${PRIVATE_DISCUSSION_BOARD_PATH}/global-proptech-summit-riyadh`,
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-summit-riyadh/proptech-summit-riyadh-logo.png`,
	},
];

const Communities = () => {
	const pathname = usePathname();
	const { portals, popularTabs } = useCountryContext();
	const isCountryPortalPage = pathname === portals.current.href;
	const communities = isCountryPortalPage
		? popularTabs?.communities ?? communityData
		: communityData;

	return (
		<div className="mx-auto mt-12 flex w-11/12 max-w-3xl flex-wrap items-center justify-center gap-6 sm:mt-12 sm:gap-8 lg:w-full">
			{communities.slice(0, 9).map((community, index) => (
				<CommunityTile
					key={index}
					labelText={community.labelText}
					title={community.title}
					labelTextClassName={community.labelTextClassName}
					href={community.href}
					logo={community.logo}
				/>
			))}
		</div>
	);
};

export default Communities;
